import {isAdminView,viewToken,clearView} from '../admin-view.js';
/**
 * useAuth -- Auth state management (reads from App.jsx token helpers)
 */

import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = import.meta.env.VITE_API_BASE || '/api';

// Duplicated from App.jsx so hooks can import without circular dep
function getToken() {
  if(isAdminView)return viewToken();
  const ls = localStorage.getItem('aigo_token');
  if (ls) return ls;
  const match = document.cookie.match(/(?:^|;\s*)aigo_token=([^;]+)/);
  return match ? match[1] : null;
}

function clearToken() {
  if(isAdminView){clearView();return;}
  localStorage.removeItem('aigo_token');
  localStorage.removeItem('aigo_gym_id');
  document.cookie = 'aigo_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure';
}

function authHeaders() {
  const token = getToken();
  if (!token) return {};
  return { 'Authorization': `Bearer ${token}` };
}

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const checkAuth = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setUser(null);
      setLoading(false);
      navigate('/login', { replace: true });
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/auth/me`, {
        headers: { 'Accept': 'application/json', ...authHeaders() },
      });

      if (res.status === 401) {
        clearToken();
        setUser(null);
        setLoading(false);
        navigate('/login', { replace: true });
        return;
      }

      if (!res.ok) throw new Error(`Auth check failed: ${res.status}`);

      const data = await res.json();
      setUser(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const logout = useCallback(() => {
    clearToken();
    setUser(null);
    navigate('/login', { replace: true });
  }, [navigate]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return { user, loading, error, logout, refetch: checkAuth };
}

export { getToken, clearToken, authHeaders };
